module.exports = __webpack_public_path__ + "img/pbl02_15.9285bb45.jpg";